import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
/*import { SeverityLevel } from "../models/severityLevel";*/
import { DateHandler } from "../helpers/dateHandler";

@Injectable({ providedIn: "root" })
export class LoggingService {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: environment.iKey
    }
  });

  constructor() {
    this.appInsights.loadAppInsights();
    this.appInsights.trackPageView();
  }

  Info(msg:any, args?: any) {
    const formattedMsg = this.formatMessage(msg, SeverityLevel.Information);
    this.appInsights.trackTrace({ message: formattedMsg + "." + args, severityLevel: SeverityLevel.Information });
  }
  Warn(msg: any, args?: any) {
    const formattedMsg = this.formatMessage(msg, SeverityLevel.Warning);
    this.appInsights.trackTrace({ message: formattedMsg + "." + args, severityLevel: SeverityLevel.Warning });
  }
  Error(msg: any, args?: any) {
    const formattedMsg = this.formatMessage(msg, SeverityLevel.Error);
    this.appInsights.trackTrace({ message: formattedMsg + "." + args, severityLevel: SeverityLevel.Error });
  }

  private formatMessage(msg: any, severityLevel: SeverityLevel) {

    const dateHandler = new DateHandler();
    const dateNow = dateHandler.getUTCNow();
    switch (severityLevel) {
      case SeverityLevel.Information:
        msg = `${dateNow} INFO ${msg}`;
        break;
      case SeverityLevel.Error:
        msg = `${dateNow} Error ${msg}`;
        break;
      case SeverityLevel.Warning:
        msg = `${dateNow} Warning ${msg}`;
        break;
      default:
        break;
    }

    return msg;
  }
}
